import ls from "../services/localStorage";
import { types } from "../constants/constants";

export const getApiBundles = (attributes: any): Promise<object> => {
  const esc = encodeURIComponent;
  const query = Object.keys(attributes).length ? '?' + Object.keys(attributes).map(k => `${esc(k)}=${esc(attributes[k])}`).join('&') : '';
  const token: string | null = ls.get("token");

  return fetch(`${types.API_URL}bundles${query}`, {
    headers: { token: token !== null ? token : '' }
  }).then(async (response) => {
    if (!response.ok) throw new Error(await response.json());
    return response.json();
  });
};

export const getApiBundle = (attributes: any): Promise<object> => {
  const token: string | null = ls.get("token");

  return fetch(`${types.API_URL}bundles/id/${attributes._id}`, {
    headers: { token: token !== null ? token : '' }
  }).then(async (response) => {
    if (!response.ok) throw new Error(await response.json());
    return response.json();
  });
};

export const postApiCreateBundle = (attributes: any): Promise<object> => {
  const token: string | null = ls.get("token");

  return fetch(`${types.API_URL}bundle/create`, {
    method: "POST",
    headers: {
      token: token !== null ? token : '',
      "Content-Type": "application/json"
    },
    body: JSON.stringify(attributes)
  }).then(async (response) => {
    if (!response.ok) throw new Error(await response.json());
    return response.json();
  });
};

export const deleteApiBundle = (id: string): Promise<object> => {
  const token: string | null = ls.get("token");

  return fetch(`${types.API_URL}bundles/delete/id/${id}`, {
    method: "DELETE",
    headers: { token: token !== null ? token : '' }
  }).then(async (response) => {
    if (!response.ok) throw new Error(await response.json());
    return response.json();
  });
};

export const putApiUpdateBundle = (attributes: any): Promise<object> => {
  const token: string | null = ls.get("token");

  return fetch(`${types.API_URL}bundles/update/id/${attributes.bundle._id}`, {
    method: "PUT",
    headers: {
      token: token !== null ? token : '',
      "Content-Type": "application/json"
    },
    body: JSON.stringify(attributes)
  }).then(async (response) => {
    if (!response.ok) throw new Error(await response.json());
    return response.json();
  });
};

export const toggleApiBundle = (id: string): Promise<object> => {
  const token: string | null = ls.get("token");

  return fetch(`${types.API_URL}bundles/toggle/id/${id}`, {
    method: "GET",
    headers: { token: token !== null ? token : '' }
  }).then(async (response) => {
    if (!response.ok) throw new Error(await response.json());
    return response.json();
  });
};
